import React from "react";

import './styles.css';
import { FormControl } from "../../facturotopia";

const SimpleCardForm = (props) => {
  const { data = {}, rules = {} } = props;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event
    }

    props.onChange({...newData})
  }

  return (
    <div className="CardForm">
      <div className="row">
        <div className="col">
          <FormControl type="text"
            label="Número de tarjeta"
            name="card_number"
            placeholder="1234 1234 1234 1234"
            mask="0000 0000 0000 0000"
            help=""
            minLength="23"
            maxLength="23"
            autoFocus={ true }
            rules={ rules.card_number }
            value={ data.card_number }
            onChange={ handleOnChange }
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormControl
            label="Fecha de expiración"
            name="card_expiration"
            placeholder="MM / AA"
            mask="00 / 00"
            minLength="7"
            maxLength="7"
            rules={ rules.card_expiration }
            value={ data.card_expiration }
            onChange={ handleOnChange }
          />
        </div>
        <div className="col">
          <FormControl type="text"
            label="CVC"
            name="card_cvc"
            placeholder="CVC"
            minLength="3"
            maxLength="4"
            help=""
            rules={ rules.card_cvc }
            value={ data.card_cvc }
            onChange={ handleOnChange }
          />
        </div>
      </div>
    </div>
  );
};

export default SimpleCardForm;
